import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import React from 'react';
import { useIsLoading, useSetLoading } from './LoadingContext';

export const QmActionButton: FC<fabric.IBaseButtonProps> = ({ onClick, disabled, ...props }) => {

  const isLoading = useIsLoading();
  const setIsLoading = useSetLoading();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | fabric.BaseButton | fabric.Button | HTMLSpanElement, MouseEvent>) => {
    setIsLoading(true);
    return onClick?.(e);
  };

  return <fabric.DefaultButton {...props} disabled={isLoading || disabled} onClick={handleClick} />;
};